<template>
  <div
    class="d-flex flex-column"
    :class="
      item.url_midia_colaboracao && !isFullScreen ? 'mb-14' : !isFullScreen ? 'mb-10' : ''
    "
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <header
      v-if="!hideUserInfo"
      class="d-flex flex-wrap-1 px-2 py-1"
      :style="headerStyle"
    >
      <v-icon size="32" class="ma-0 pa-0 px-1 mr-2" :style="iconStyle">
        mdi-message-outline
      </v-icon>
      <div class="d-flex align-center">
        <span
          class="text-uppercase"
          :style="!isFullScreen ? 'color: #353535' : 'color: rgb(247, 247, 248)'"
          style="font-size: 1.2rem; font-weight: 600"
          :class="isFullScreen ? 'text-h4' : 'text-h5'"
        >
          <template v-if="flg_exibir_uf && item.dsc_uf_colaborador">
            {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
          </template>
          <template v-else>
            {{ item.dsc_nome_colaborador }}
          </template>
        </span>
      </div>
    </header>
    <section class="d-flex align-center flex-grow-1" :style="sectionStyle">
      <div
        v-if="renderMode === 'text'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal colab-text"
        style="color: rgb(247, 247, 248)"
        :style="{ lineHeight: lineHeight, fontSize: bodyTextSize }"
      ></div>
      <div
        v-else-if="renderMode === 'texto_fullscreen'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal"
        style="color: rgb(166, 3, 192)"
        :style="{
          lineHeight: lineHeightFullScreenJustText,
          fontSize: bodyTextSizeFullScreenJustText,
          wordBreak: 'break-word',
        }"
      ></div>
      <div
        v-else-if="renderMode === 'audio'"
        style="width: 100%"
        class="d-flex align-center align-self-center justify-center px-8"
      >
        <audio
          controls
          controlslist="nodownload"
          autoplay
          style="width: 100%"
          :key="item.url_midia_colaboracao"
        >
          <source :src="item.url_midia_colaboracao" />
        </audio>
      </div>
      <div
        v-else-if="renderMode === 'midia'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center justify-center pa-2'
            : 'pa-2'
        "
        :id="`${item.id_colaboracao}-wrapper`"
      >
        <img
          v-if="item.dsc_tipo_midia_colaboracao === 'image'"
          :id="`${item.id_colaboracao}`"
          :src="item.url_midia_colaboracao"
          :style="
            isFullScreen
              ? `max-width: ${
                  (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                }px;
                                                                                    min-width: ${
                                                                                      (percentScreenDim.fullScreenMinWidth *
                                                                                        screenDimensions.width) /
                                                                                      100
                                                                                    }px;
                                                                                    max-height: ${
                                                                                      (percentScreenDim.fullScreenMaxHeight *
                                                                                        screenDimensions.height) /
                                                                                      100
                                                                                    }px;
                                                                                    min-height: ${
                                                                                      (percentScreenDim.fullScreenMinHeight *
                                                                                        screenDimensions.height) /
                                                                                      100
                                                                                    }px;`
              : `max-width: ${
                  (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                }px; 
                                                                                     max-height: ${
                                                                                       (percentScreenDim.maxHeight *
                                                                                         screenDimensions.height) /
                                                                                         100 -
                                                                                       50
                                                                                     }px`
          "
        />
        <video
          v-if="item.dsc_tipo_midia_colaboracao === 'video'"
          autoplay
          :id="`${item.id_colaboracao}`"
          :key="item.url_midia_colaboracao"
          style="justify-self: center"
          :style="
            isFullScreen
              ? `max-height: ${
                  (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                }px; 
                                                                                    max-width: ${
                                                                                      (percentScreenDim.fullScreenMaxWidth *
                                                                                        screenDimensions.width) /
                                                                                      100
                                                                                    }px`
              : `max-width: 100%;
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              50
                                            }px`
          "
        >
          <source :src="item.url_midia_colaboracao" />
        </video>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto_fullscreen'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center pa-2'
            : 'pa-2'
        "
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                                                                                max-height: ${
                                                                                                  (percentScreenDim.fullScreenMaxHeight *
                                                                                                    screenDimensions.height) /
                                                                                                  100
                                                                                                }px;
                                                                                                min-height: ${
                                                                                                  (percentScreenDim.fullScreenMinHeight *
                                                                                                    screenDimensions.height) /
                                                                                                  100
                                                                                                }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                                                                max-height: ${
                                                                                                  (percentScreenDim.maxHeight *
                                                                                                    screenDimensions.height) /
                                                                                                    100 -
                                                                                                  50
                                                                                                }px`
            "
          />
          <video
            v-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                                                                max-width: ${
                                                                                                  (percentScreenDim.fullScreenMaxWidth *
                                                                                                    screenDimensions.width) /
                                                                                                  100
                                                                                                }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                                                                max-height: ${
                                                                                                  (percentScreenDim.maxHeight *
                                                                                                    screenDimensions.height) /
                                                                                                    100 -
                                                                                                  50
                                                                                                }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <div
            v-html="item.dsc_texto_colaboracao"
            class="px-3 py-3 font-weight-normal"
            style="color: rgb(166, 3, 192)"
            :style="{
              lineHeight: lineHeightFullScreen,
              fontSize: bodyTextSizeFullScreen,
              wordBreak: 'break-word',
            }"
          ></div>
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex align-center justify-center"
        >
          <div class="pa-2 d-flex">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.fullScreenMaxHeight +
                                                                                                            10 *
                                                                                                              screenDimensions.height) /
                                                                                                          100
                                                                                                        }px;
                                                                                                        min-height: ${
                                                                                                          (percentScreenDim.fullScreenMinHeight *
                                                                                                            screenDimensions.height) /
                                                                                                          100
                                                                                                        }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.maxHeight *
                                                                                                            screenDimensions.height) /
                                                                                                            100 -
                                                                                                          50
                                                                                                        }px`
              "
            />
            <video
              v-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                                                                        max-width: ${
                                                                                                          (percentScreenDim.fullScreenMaxWidth *
                                                                                                            screenDimensions.width) /
                                                                                                          100
                                                                                                        }px`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.maxHeight *
                                                                                                            screenDimensions.height) /
                                                                                                            100 -
                                                                                                          50
                                                                                                        }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
            <!-- <div v-html="item.dsc_texto_colaboracao" class="px-3 py-3 font-weight-normal"
                            style="color: rgb(247, 247, 248);"
                            :style="{ 'lineHeight': lineHeightFullScreen, 'fontSize': bodyTextSizeFullScreen, wordBreak: 'break-word' }">
                        </div> -->
          </div>
        </div>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image' && midiaOrientation === 'horizontal'
            ? 'd-flex align-center justify-center pa-2'
            : item.dsc_tipo_midia_colaboracao === 'video' &&
              midiaOrientation === 'horizontal'
            ? 'pa-2'
            : ''
        "
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            id="image"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                            min-width: ${
                                              (percentScreenDim.fullScreenMinWidth *
                                                screenDimensions.width) /
                                              100
                                            }px;
                                            max-height: ${
                                              (percentScreenDim.fullScreenMaxHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;
                                            min-height: ${
                                              (percentScreenDim.fullScreenMinHeight *
                                                screenDimensions.height) /
                                              100
                                            }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px;
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              100
                                            }px`
            "
          />
          <video
            v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                max-width: ${
                                                  (percentScreenDim.fullScreenMaxWidth *
                                                    screenDimensions.width) /
                                                  100
                                                }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                            max-height: ${
                                              (percentScreenDim.maxHeight *
                                                screenDimensions.height) /
                                                100 -
                                              50
                                            }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <!-- <div v-html="item.dsc_texto_colaboracao" class="px-3 py-3 font-weight-normal colab-text"
                        style="color: rgb(247, 247, 248);" :style="{ 'lineHeight': lineHeight, 'fontSize': bodyTextSize }">
                    </div> -->
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex"
        >
          <div class="pa-2">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              id="image"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                                                                        min-width: ${
                                                                                                          (percentScreenDim.fullScreenMinWidth *
                                                                                                            screenDimensions.width) /
                                                                                                          100
                                                                                                        }px;
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.fullScreenMaxHeight *
                                                                                                            screenDimensions.height) /
                                                                                                          100
                                                                                                        }px;
                                                                                                        min-height: ${
                                                                                                          (percentScreenDim.fullScreenMinHeight *
                                                                                                            screenDimensions.height) /
                                                                                                          100
                                                                                                        }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                        max-height: ${
                                                                                                          (percentScreenDim.maxHeight *
                                                                                                            screenDimensions.height) /
                                                                                                            100 -
                                                                                                          50
                                                                                                        }px`
              "
            />
            <video
              v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                                                                        max-width: ${
                                                                                                          (percentScreenDim.fullScreenMaxWidth *
                                                                                                            screenDimensions.width) /
                                                                                                          100
                                                                                                        }px`
                  : `max-width: 100%; 
                                                max-height: ${
                                                  (percentScreenDim.maxHeight *
                                                    screenDimensions.height) /
                                                    100 -
                                                  50
                                                }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
          </div>
          <div
            class="d-flex flex-column align-self-end"
            style="min-height: 160px; max-height: 180px"
            :style="`max-width: ${(33.5 * screenDimensions.width) / 100}px;
                                min-width: ${(33.5 * screenDimensions.width) / 100}px`"
          >
            <header
              v-if="
                !hideUserInfo &&
                item.url_midia_colaboracao &&
                item.dsc_texto_colaboracao &&
                midiaOrientation === 'vertical'
              "
              class="d-flex flex-wrap-1 px-2"
            >
              <v-icon
                size="42"
                class="ma-0 pa-0 ml-1"
                color="#353535"
                style="transform: scaleX(-1)"
              >
                mdi-chat-outline
              </v-icon>
              <div class="d-flex align-center">
                <span
                  class="text-uppercase ml-2"
                  style="color: #353535 !important; font-weight: 600"
                  :class="isFullScreen ? 'text-h4' : 'text-h5'"
                >
                  {{
                    item.dsc_nome_colaborador && item.dsc_uf_colaborador
                      ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
                      : item.dsc_nome_colaborador && !item.dsc_uf_colaborador
                      ? `${item.dsc_nome_colaborador}`
                      : ""
                  }}
                </span>
              </div>
            </header>
            <!-- <div v-html="item.dsc_texto_colaboracao"
                            class="px-3 py-3 font-weight-normal d-flex align-center align-self-center colab-text"
                            style="color: rgb(247, 247, 248);"
                            :style="{ 'lineHeight': lineHeight, 'fontSize': bodyTextSize }">
                        </div> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flg_exibir_uf: Boolean,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      divMidiaWrapperDimension: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 30,
        minWidth: 20,
        minHeight: 40,
        maxHeight: 60,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 70,
        fullScreenMinWidth: 40,
        fullScreenMinHeight: 50,
      },
    };
  },
  created() {
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    renderMode() {
      if (
        this.item.dsc_tipo_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return "audio";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        (!this.item.dsc_texto_colaboracao || !this.item.flg_exibir_texto)
      ) {
        return "midia";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen
      ) {
        return "midia_texto_fullscreen";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.flg_exibir_texto &&
        this.item.dsc_texto_colaboracao &&
        !this.isFullScreen
      ) {
        return "midia_texto";
      } else if (
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen &&
        !this.url_midia_colaboracao
      ) {
        return "texto_fullscreen";
      }
      return "text";
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "2rem"
          : numChars > 80 && numChars <= 120
          ? "1.8rem"
          : numChars > 120 && numChars <= 160
          ? "1.65rem"
          : numChars > 160 && numChars <= 200
          ? "1.5rem"
          : numChars > 200 && numChars <= 240
          ? "1.4rem"
          : numChars > 240 && numChars <= 280
          ? "1.25rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.3rem"
          : numChars > 40 && numChars <= 80
          ? "2.1rem"
          : numChars > 80 && numChars <= 120
          ? "1.9rem"
          : numChars > 120 && numChars <= 160
          ? "1.8rem"
          : numChars > 160 && numChars <= 200
          ? "1.7rem"
          : numChars > 200 && numChars <= 240
          ? "1.6rem"
          : numChars > 240 && numChars <= 280
          ? "1.45rem"
          : "1.5rem";

      return lineHeight;
    },
    bodyTextSizeFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.4rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2.1rem"
          : numChars > 240 && numChars <= 280
          ? "2.5rem"
          : "1.5rem";
      return size;
    },
    bodyTextSizeFullScreenJustText() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "4.2rem"
          : numChars > 40 && numChars <= 80
          ? "3.9rem"
          : numChars > 80 && numChars <= 120
          ? "3.7rem"
          : numChars > 120 && numChars <= 160
          ? "3.5rem"
          : numChars > 160 && numChars <= 200
          ? "3.1rem"
          : numChars > 200 && numChars <= 240
          ? "3rem"
          : numChars > 240 && numChars <= 280
          ? "3rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreenJustText() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "4.4rem"
          : numChars > 40 && numChars <= 80
          ? "4.2rem"
          : numChars > 80 && numChars <= 120
          ? "4rem"
          : numChars > 120 && numChars <= 160
          ? "3.9rem"
          : numChars > 160 && numChars <= 200
          ? "3.8rem"
          : numChars > 200 && numChars <= 240
          ? "3.7rem"
          : numChars > 240 && numChars <= 280
          ? "3.5rem"
          : "1.5rem";

      return lineHeight;
    },
    lineHeightFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.8rem"
          : numChars > 80 && numChars <= 120
          ? "2.6rem"
          : numChars > 120 && numChars <= 160
          ? "2.5rem"
          : numChars > 160 && numChars <= 200
          ? "2.4rem"
          : numChars > 200 && numChars <= 240
          ? "2.3rem"
          : numChars > 240 && numChars <= 280
          ? "2.8rem"
          : "1.5rem";

      return lineHeight;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    iconStyle() {
      if (this.isFullScreen) {
        return "color: rgb(247, 247, 248)";
      }
      return `background: rgb(246,11,48);
                    background: -moz-linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                    background: -webkit-linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                    background: linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f60b30",endColorstr="#353535",GradientType=1);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent; 
                    -moz-background-clip: text;
                    -moz-text-fill-color: transparent;`;
    },
    headerStyle() {
      if (!this.isFullScreen) {
        return "background-color: rgb(247, 267, 248);";
      }
      const linearGradientBackground = `background: rgb(163,3,197);
                                                background: -moz-linear-gradient(90deg, rgba(163,3,197,1) 0%, rgba(214,8,106,1) 50%, rgba(246,11,48,1) 100%);
                                                background: -webkit-linear-gradient(90deg, rgba(163,3,197,1) 0%, rgba(214,8,106,1) 50%, rgba(246,11,48,1) 100%);
                                                background: linear-gradient(90deg, rgba(163,3,197,1) 0%, rgba(214,8,106,1) 50%, rgba(246,11,48,1) 100%);
                                                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f60b30",endColorstr="#353535",GradientType=1);`;
      return linearGradientBackground;
    },
    sectionStyle() {
      if (this.isFullScreen) {
        return "background-color: rgb(247, 267, 248);";
      }
      const linearGradientBackground = `background: rgb(246,11,48);
                                                background: -moz-linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                                                background: -webkit-linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                                                background: linear-gradient(90deg, rgba(246,11,48,1) 0%, rgba(214,8,106,1) 50%, rgba(163,3,197,1) 100%);
                                                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f60b30",endColorstr="#353535",GradientType=1);`;
      return linearGradientBackground;
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        if (this.renderMode === "texto_fullscreen") {
          minWidth =
            (this.percentScreenDim.fullScreenMinWidth -
              10 * this.screenDimensions.width) /
            100;
          minHeight =
            (this.percentScreenDim.fullScreenMinHeight -
              30 * this.screenDimensions.height) /
            100;
        }
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                         min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
        return fullScreenStyle;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-end"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      // regras para visualização normal, sem modo tela cheia

      maxWidth = (this.percentScreenDim.maxWidth * this.screenDimensions.width) / 100; // 40% of screen width
      maxHeight = (this.percentScreenDim.maxHeight * this.screenDimensions.height) / 100; // 80% of screen height

      // const textMaxWidth = (33.5 * this.screenDimensions.width) / 100; // 40% of screen width
      // const textMaxHeight = (15.5 * this.screenDimensions.height) / 100; // 20% of screen height)
      const dimensions =
        ["video", "image"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        !this.item.dsc_texto_colaboracao
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "horizontal"
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "vertical"
          ? `max-width: auto !important; max-height: ${maxHeight}px !important;`
          : `width: 640px; height: 160px;`;

      const array = position.split(";").concat(dimensions.split(";"));
      return array.filter((item) => item).join(";");
    },
  },
  methods: {
    getDivMidiaWrapperDimension() {
      if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "video"
      ) {
        const item = document.getElementById(`${this.item.id_colaboracao}`);
        return { width: item.offsetWidth, height: item.offsetHeight };
      }
      return null;
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: function (newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
        this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
      this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

section {
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

@media only screen and (max-width: 1367px) and (max-height: 769px) {
  // .colab-text {
  //     font-size: calc(v-bind('bodyTextSize') - .0rem) !important;
  //     line-height: calc(v-bind('lineHeight') - .2rem) !important;
  //     // color: red !important;
  // }
}
</style>
